import React, { useCallback } from 'react';
import TPGrid from 'components/TP-UI/TPGrid';
import { useTranslation } from 'react-i18next';
import TPTypography from 'components/TP-UI/TPTypography';
import { Field } from 'redux-form';
import { required, phoneNumber as checkPhoneNumber } from 'utils/validation/fieldValidationRules';
import PropTypes from 'prop-types';
import TPPhoneTextField from 'components/TP-UI/TPPhoneTextField';

const MfaPhoneNumberForm = ({ alphabeticalCountries }) => {
  const { t } = useTranslation('auth');

  const validatePhoneNumber = useCallback((value) => {
    const phone = value ? value.phoneNumber : '';
    return checkPhoneNumber(phone);
  }, []);

  const validatePhoneRequired = useCallback((value) => {
    const phone = value ? value.phoneNumber : '';
    return required(phone);
  }, []);

  return (
    <TPGrid container spacing={2}>
      <TPGrid item xs={12}>
        <TPTypography>{t('mfa.setupPhoneForm.description')}</TPTypography>
      </TPGrid>
      <TPGrid item xs={12}>
        <Field
          name="phoneInfo"
          id="phoneInfo"
          label={t('common:labels.phoneNumber')}
          type="number"
          component={TPPhoneTextField}
          options={alphabeticalCountries}
          grouped
          fullWidth
          required
          returnsObject
          validate={[validatePhoneRequired, validatePhoneNumber]}
        />
      </TPGrid>
    </TPGrid>
  );
};

MfaPhoneNumberForm.propTypes = {
  alphabeticalCountries: PropTypes.array,
};

export default MfaPhoneNumberForm;
